// Beta feature keys, PostHog-only; see docs/specs/09-infrastructure.md "Beta features".
export const betaFeatures = ['ShowBetaBadge'] as const;
